import axios from "axios";

let url = process.env.VUE_APP_API;

class AuthService {


    login(user) {
        return axios.post(url + '/api/account/login', {
                email: user.email,
                password: user.password,
                rememberMe: user.rememberMe
            }
        ).then(
            (response) => {
                if (response.data.data.accessToken) {
                    localStorage.setItem('token', response.data.data.accessToken);
                    localStorage.setItem('refreshToken', response.data.data.refreshToken);
                    localStorage.setItem('user', response.data.data.user);
                    localStorage.setItem('userName', response.data.data.userName);
                }
                return response.data.token;
            }
        )
    }

    logout() {
        return axios.get(url + '/api'
        ).then(
            (response) => {
                localStorage.removeItem('token');
                localStorage.removeItem('refreshToken');
                localStorage.removeItem('user');
                localStorage.removeItem('userName');
                return response.data;
            }
        )

    }
}

export default new AuthService();